import { useUpgradePlanMutationApi } from '@aibees/shared/api';
import { SubscriptionActiveAction } from '@aibees/shared/definition';
import { SHARED_ROUTES } from '@aibees/shared/constants';
import { useState } from 'react';
import { usePlanCardContext } from '../../plan-card/context';
import { SubscriptionFlow } from '../types';
import { useSubscriptionModals } from './use-subscription-modals';

export function useUpgrade(): SubscriptionFlow {
  const { activeModal, closeModal } = useSubscriptionModals();
  const { selectedPlan } = usePlanCardContext();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const immediatelyApi = useUpgradePlanMutationApi(
    SubscriptionActiveAction.IMMEDIATELY
  );

  // ---------------------------------- Handlers --------------------------------
  const handleStart = () => {
    setIsLoading(true);
    if (!selectedPlan) return;
    immediatelyApi
      .mutateAsync({
        plan: selectedPlan?.id,
        redirect: {
          success: window.origin + SHARED_ROUTES.priceAndPlanSuccessUpgrade,
          failed: window.origin + SHARED_ROUTES.priceAndPlanSuccessFailure,
        },
      })
      .then((data) => {
        window.location.href = data.url;
      });
  };

  return {
    activeModal,
    onStart: handleStart,
    closeModal,
  };
}
